import * as React from "react";
import { 
  makeStyles, 
  tokens, 
  Tab, 
  TabList,
  SelectTabData,
  SelectTabEvent,
  shorthands
} from "@fluentui/react-components";
import { 
  Save24Regular,
  DocumentMultiple24Regular
} from "@fluentui/react-icons";

interface TabLayoutProps {
  children: React.ReactNode;
  onTabChange: (tab: string) => void;
  selectedTab: string;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    height: "100vh",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  sidebar: {
    width: "60px",
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRight("1px", "solid", tokens.colorNeutralStroke2),
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding(tokens.spacingVerticalM, "0"),
  },
  tabList: {
    flexDirection: "column",
    width: "100%",
  },
  tab: {
    width: "100%",
    justifyContent: "center",
    ...shorthands.padding(tokens.spacingVerticalM),
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground2,
    },
  },
  content: {
    flex: 1,
    overflow: "auto",
  },
});

export const TabLayout: React.FC<TabLayoutProps> = ({ children, onTabChange, selectedTab }) => {
  const styles = useStyles();

  const handleTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
    onTabChange(data.value as string);
  };

  return (
    <div className={styles.root}>
      <div className={styles.sidebar}>
        <TabList 
          className={styles.tabList}
          selectedValue={selectedTab}
          onTabSelect={handleTabSelect}
          vertical
        >
          <Tab 
            className={styles.tab}
            value="save" 
            icon={<Save24Regular />}
            title="Save Email"
          />
          <Tab 
            className={styles.tab}
            value="list" 
            icon={<DocumentMultiple24Regular />}
            title="Email List"
          />
        </TabList>
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default TabLayout;
